import React, { useEffect, useState } from "react";
import { useApi } from "../../api/useApi";
import { tagsList } from "../../api/tagQueries";
import { Label, StyledSelect } from "../Form/FormControls";

const formatTransformOptionLabel = (options, { context }) => {
  const isValue = context === "value";
  return (
    <div style={{ display: "flex", flexDirection: "column", padding: ".5rem" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "1.1rem",
          marginBottom: isValue ? "" : ".3rem",
        }}
      >
        {options?.label}
      </div>
      {options?.tag?.description && !isValue && (
        <div
          style={{
            opacity: 0.5,
            fontSize: "1rem",
            position: "relative",
            display: "block",
            maxWidth: "100%",
            whiteSpace: "normal",
          }}
        >
          {options?.tag?.description}
        </div>
      )}
    </div>
  );
};

const SelectTags = ({
  currentTags = [],
  updateTags,
  fieldName,
  tagType = "DATA_SOURCE",
  loadingIndicator,
  dispatchType,
  exactMatch,
}) => {
  //Available Users Via Graph
  const [{ loading, errors, data }] = useApi(tagsList);
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    if (currentTags && currentTags?.length) {
      const tags = currentTags.map((ct) => {
        const createTagOption = {
          label: ct?.tag?.name,
          value: ct?.tagId,
          ...ct,
        };

        return createTagOption;
      });
      setSelectedTags(tags);
    }
  }, [currentTags]);

  const allTags = data?.allTags ?? [];

  const setTags = React.useCallback(
    (values) => {
      setSelectedTags(values);
    },
    [setSelectedTags]
  );

  useEffect(() => {
    if (updateTags && selectedTags) {
      function setTagsObj(tags) {
        const builtTagsObj = tags.map((t) => {
          return {
            name: t?.tag?.name,
            tagId: t?.tag?.id,
            type: tagType,
          };
        });

        return builtTagsObj ?? [];
      }

      //Dealing with Formik Updates
      if (updateTags && fieldName) {
        updateTags(fieldName, setTagsObj(selectedTags));
      } else if (updateTags && dispatchType) {
        updateTags({ type: dispatchType, payload: setTagsObj(selectedTags) });
      } else {
        updateTags(setTagsObj(selectedTags));
      }
    }
  }, [selectedTags, updateTags, fieldName, tagType, dispatchType]);

  const tagOptions = allTags.map((tag) => {
    return {
      label: tag?.name,
      value: tag?.id,
      tag: { ...tag },
    };
  });

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Label>Filter by tags</Label>
        {exactMatch && (
          <div style={{ marginLeft: "auto" }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "0.5em",
                fontSize: ".8rem",
              }}
            >
              <input
                name={`ExactMatch`}
                type="checkbox"
                onChange={() => {
                  exactMatch((prev) => !prev);
                }}
              />
              Exact Match
            </label>
          </div>
        )}
      </div>

      <StyledSelect
        className={`react-select-container`}
        classNamePrefix={`react-select`}
        name={`Tags`}
        id={`Tags`}
        inputId={`Tags-input`}
        instanceId={`Tags-instance`}
        menuPortalTarget={document.body}
        placeholder={
          loading || loadingIndicator
            ? `Loading Tags`
            : errors
            ? "Error loading Tags"
            : `Select Tags`
        }
        label="Select Tags"
        value={selectedTags}
        isMulti={true}
        options={tagOptions}
        formatOptionLabel={formatTransformOptionLabel}
        onChange={(e) => setTags(e)}
      />
    </>
  );
};
export default SelectTags;
